import { type IvantiTier, useCapabilities } from "@/lib/api";

/** Every tier that gets labelled — all of them except LIVE. */
export type LabelledTier = Exclude<IvantiTier, "LIVE">;

/**
 * Which Ivanti tenant this deployment raises tickets in, or `null` for LIVE.
 *
 * LIVE is the product and keeps its look; every other tier is labelled so a
 * tester can never mistake the UAT or STG portal for the real one. `null`
 * while capabilities load too: flashing a banner on LIVE would be worse than
 * showing it a moment late elsewhere.
 */
export function useEnvironmentTier(): LabelledTier | null {
  const { data } = useCapabilities();
  const tier = data?.ivanti_tier;
  return tier && tier !== "LIVE" ? tier : null;
}
